import React, {Fragment} from 'react';
import {connect} from 'react-redux';

import {bindActionCreators} from "redux";
import {PageLoader} from "../../../components/Loader";
import _ from "lodash";

import {fetchCategorizedMedias, resetCategorizedMedias} from "../../../../creators/categorized.medias";
import Thumb from "../../../components/Thumb";
import Aqp from "../../../../libs/mk-react-aqp";
import PaginationByAncre from "../PaginationByAncre";
import {
    fetchFacetteSuggestion,
    resetFacetteSuggestion
} from "../../../../creators/facette.suggestion";
import {Link} from "react-router-dom";
import SideBar from "./SideBar";
import {Breakpoint} from "../../../../libs/breakpoint";
import {Button} from "../../../components/Button";
import Modal from "../../../components/Modal";
import {separateurNumber} from "../../../../libs/helper";
import createLink from "../../../../libs/createLink";




class Content extends React.Component {
    constructor(props) {
        super(props);

        this.filter = {
            limit: 32,
            sort: "-createdAt",
            page: 1,
            categoryId : this.props.categories,
            right : "guest"
        };
        this.facetteUri = _.get(this.props,"match.params.categorySlug");
        if(this.facetteUri && this.facetteUri !== "" && !this.facetteUri.endsWith("/")){
            this.facetteUri = `${this.facetteUri}/`;
        }
        //let urlSearchParams = new URLSearchParams(this.props.location.hash.replace("#", ""));
        //let page = parseInt(urlSearchParams.get("page") || 1);
        let page = _.get(this.props,'match.params.page') || 1;

        this.aqp = new Aqp({}, {
            blacklist: ['limit', 'page', 'kind'],
            currentLink: createLink('facette', this.facetteUri ? {slug : this.facetteUri} : {}),
            filterDefault: this.filter
        });

        this.state = {
            filter: {...this.filter, ...this.aqp.query, page},
            toggle : false
        };

        this.handleChangePage = this.handleChangePage.bind(this);

        this.props.resetCategorizedMedias();
        this.props.resetFacetteSuggestion();
        if(_.get(this.props,"categories").length){
            this.props.fetchCategorizedMedias(this.state.filter);
        }
        if(this.props.facetteId){
            this.props.fetchFacetteSuggestion(this.props.facetteId, {sort : "-count", limit : 5});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.lastUpdate !== this.props.lastUpdate || prevProps.categories.length !== this.props.categories.length){
            this.props.resetCategorizedMedias();
            this.props.fetchCategorizedMedias(this.state.filter);
        }
        /*if(prevProps.location.hash !== this.props.location.hash){
            this.props.resetCategorizedMedias();
            let urlSearchParams = new URLSearchParams(this.props.location.hash.replace("#", ""));
            let page = parseInt(urlSearchParams.get("page") || 1);
            let filter = {
                ...this.state.filter,
                page,
            }
            this.setState({filter})
            this.props.fetchCategorizedMedias(filter);
        }*/
    }

    handleChangePage(page) {
        let filter = {
            ...this.state.filter,
            page,
        }
        this.setState({filter}, ()=> {
            this.props.resetCategorizedMedias();
            this.props.fetchCategorizedMedias(filter);
        });
        window.scrollTo(0, 0);
    }

    render() {
        //console.log(this.props.categorizedMedias);

        let totalPage = this.props.categorizedMediasTotal ? Math.ceil(this.props.categorizedMediasTotal / this.state.filter.limit) : 0;
        return !this.props.categorizedMediasInitialized ? (
            <div className={"content"}>
                <PageLoader/>
            </div>
            )
            :(
                <div className={"content"}>
                    <h1>{this.props.titleH1 || this.props.category.title}</h1>
                    <div className={"results-count"}>{separateurNumber(this.props.categorizedMediasTotal)} media{this.props.categorizedMediasTotal > 1 ? 's' : ''}</div>
                    <Breakpoint sizeBelow="sm">
                        <Button
                                className={"affiner-button w-100 mb-8"}
                                size={"large"}
                                btnStyle={"primary-reverse"}
                                onClick={() => this.setState({toggle : true})}
                                icon={"sliders"}
                                iconSide={"left"}
                                content={"Affiner"}/>
                        <Modal toggle={this.state.toggle} className={"moteur-a-facettes"} handleClose={() => this.setState({toggle : false})}>
                            <div id="facettes">
                                <SideBar
                                    categoryId={this.props.categoryId}
                                    handleCategories={this.props.handleCategories}
                                    lastUpdate={this.props.lastUpdate}
                                    categories={this.props.categories}
                                    facetteId={_.get(this.props,"facetteId")}
                                    facetteAncre={_.get(this.props, 'facetteAncre')}
                                />
                            </div>
                        </Modal>
                    </Breakpoint>
                    {this.props.facetteSuggestion && this.props.facetteSuggestion.length ? (
                        <Fragment>
                            <div className={"suggestions-sentence"}>Voulez-vous préciser votre recherche ?</div>
                            <div className={"suggestions-group"}>
                                {this.props.facetteSuggestion.map(item=>(
                                    <Link key={item._id} to={createLink('facette', {slug : item.uri})}>
                                        <Button
                                            size={"small"}
                                            btnStyle={"primary-reverse"}
                                            //onClick={() => this.setState({toggle : true})}
                                            content={item.title}/>
                                    </Link>
                                ))}
                            </div>
                        </Fragment>
                    ) : null}
                    <div className={"thumbs-grid"}>
                        {this.props.categorizedMedias.map(media=>(
                            <Thumb key={media._id} {...media} cropTitle={45} />
                        ))}
                    </div>

                    <div className={"w-100 mt-16"}>
                        {totalPage > 1 &&
                        <PaginationByAncre
                            currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            handleChangePage={this.handleChangePage}
                            paramsUrl={this.props.location.hash}
                            {...this.aqp.queryUrl(this.state.filter, {})}
                        />
                        }
                    </div>
                </div>

            )
    }
}

const mapStateToProps = (state) => {
    return {

        categorizedMedias : state.categorizedMedias.data,
        categorizedMediasTotal : state.categorizedMedias.total,
        categorizedMediasInitialized : state.categorizedMedias.initialized,
        categorizedMediasLoading : state.categorizedMedias.loading,

        facetteSuggestion : state.facetteSuggestion.data,
        facetteSuggestionInitialized : state.facetteSuggestion.initialized,
        facetteSuggestionLoading : state.facetteSuggestion.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategorizedMedias,
    resetCategorizedMedias,
    fetchFacetteSuggestion,
    resetFacetteSuggestion
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Content);
